import React from "react";
import camelToTitleCase from "../../../camelToTitleCase";

function formatDisplayValue(value) {
  if (value == null) return "—";
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (item == null) return "—";
        if (typeof item === "object") return item.name ?? item.id ?? "—";
        return String(item);
      })
      .filter(Boolean);
  }
  return value;
}

function ProfileFieldRow({ icon, label, value, children, className = "" }) {
  const resolved = formatDisplayValue(value);
  const isArrayValue = Array.isArray(value) && Array.isArray(resolved);
  const displayValue =
    children !== undefined && children !== null ? children : resolved;

  return (
    <div
      className={`profile-field-row d-flex align-items-start gap-2 py-2 border-bottom border-light ${className}`.trim()}
    >
      {icon && (
        <i
          className={`${icon} text-muted flex-shrink-0 mt-0`}
          style={{ fontSize: "1rem" }}
          aria-hidden
        />
      )}
      <div className="flex-grow-1 min-w-0">
        <div className="text-muted small mb-0 fw-thin">
          {camelToTitleCase(label)}
        </div>
        <div className="fw-medium">
          {isArrayValue ? (
            displayValue.length > 0 ? (
              <span className="d-flex flex-wrap gap-1">
                {displayValue.map((part, i) => (
                  <span
                    key={i}
                    className="badge rounded text-secondary border border-secondary px-2 py-1 fw-medium"
                  >
                    {part}
                  </span>
                ))}
              </span>
            ) : (
              "—"
            )
          ) : (
            (displayValue ?? "—")
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfileFieldRow;
